import React, { useState, useEffect } from 'react';
import { getHistory } from './adminApi';
import './History.css';

const History = () => {
  const [history, setHistory] = useState([]);
  const [loading, setLoading] = useState(true);
  const [pagination, setPagination] = useState({ page: 1, page_size: 20, total: 0 });
  const [filters, setFilters] = useState({
    module: '',
    user_id: '',
    start_date: '',
    end_date: ''
  });

  useEffect(() => {
    fetchHistory();
  }, [pagination.page, filters.module]);

  const fetchHistory = async () => {
    try {
      setLoading(true);
      const params = { page: pagination.page, page_size: pagination.page_size };
      
      if (filters.module) params.module = filters.module;
      if (filters.user_id) params.user_id = filters.user_id;
      if (filters.start_date) params.start_date = filters.start_date;
      if (filters.end_date) params.end_date = filters.end_date;

      const result = await getHistory(params);
      setHistory(result.items);
      setPagination(prev => ({ ...prev, total: result.total }));
    } catch (err) {
      console.error('获取历史记录失败:', err);
    } finally {
      setLoading(false);
    }
  };

  const handleSearch = (e) => {
    e.preventDefault();
    setPagination(prev => ({ ...prev, page: 1 }));
    fetchHistory();
  };

  const getModuleLabel = (module) => {
    const labels = {
      document: '公文排版',
      schedule: '行程排版',
      tableSign: '台签排版',
      unitSort: '单位排版'
    };
    return labels[module] || module;
  };

  const totalPages = Math.ceil(pagination.total / pagination.page_size);

  return (
    <div className="history-page">
      <div className="page-header">
        <h2 className="page-title">历史记录管理</h2>
      </div>

      {/* 搜索和筛选 */}
      <div className="admin-card">
        <form className="admin-search-bar" onSubmit={handleSearch}>
          <select
            className="admin-select"
            style={{ width: 'auto' }}
            value={filters.module}
            onChange={(e) => setFilters({ ...filters, module: e.target.value })}
          >
            <option value="">全部模块</option>
            <option value="document">公文排版</option>
            <option value="schedule">行程排版</option>
            <option value="tableSign">台签排版</option>
            <option value="unitSort">单位排版</option>
          </select>
          <input
            type="number"
            className="admin-input"
            style={{ width: '120px' }}
            placeholder="用户ID"
            value={filters.user_id}
            onChange={(e) => setFilters({ ...filters, user_id: e.target.value })}
          />
          <input
            type="date"
            className="admin-input"
            style={{ width: 'auto' }}
            value={filters.start_date}
            onChange={(e) => setFilters({ ...filters, start_date: e.target.value })}
          />
          <input
            type="date"
            className="admin-input"
            style={{ width: 'auto' }}
            value={filters.end_date}
            onChange={(e) => setFilters({ ...filters, end_date: e.target.value })}
          />
          <button type="submit" className="admin-btn admin-btn-primary">搜索</button>
        </form>
      </div>

      {/* 历史记录列表 */}
      <div className="admin-card">
        {loading ? (
          <div className="admin-loading"><div className="admin-loading-spinner"></div></div>
        ) : (
          <>
            <table className="admin-table">
              <thead>
                <tr>
                  <th>ID</th>
                  <th>模块</th>
                  <th>用户</th>
                  <th>标题</th>
                  <th>创建时间</th>
                </tr>
              </thead>
              <tbody>
                {history.map((item, index) => (
                  <tr key={`${item.module}-${item.id}-${index}`}>
                    <td>{item.id}</td>
                    <td>
                      <span className={`admin-tag admin-tag-${item.module === 'document' ? 'info' : item.module === 'schedule' ? 'success' : 'warning'}`}>
                        {getModuleLabel(item.module)}
                      </span>
                    </td>
                    <td>
                      {item.username}
                      <span className="user-id-hint">(ID: {item.user_id})</span>
                    </td>
                    <td>{item.title}</td>
                    <td>{item.created_at}</td>
                  </tr>
                ))}
                {history.length === 0 && (
                  <tr>
                    <td colSpan="5" className="admin-empty">暂无历史记录</td>
                  </tr>
                )}
              </tbody>
            </table>

            {/* 分页 */}
            {totalPages > 1 && (
              <div className="admin-pagination">
                <button 
                  disabled={pagination.page === 1}
                  onClick={() => setPagination(prev => ({ ...prev, page: prev.page - 1 }))}
                >
                  上一页
                </button>
                <span>第 {pagination.page} / {totalPages} 页</span>
                <button 
                  disabled={pagination.page === totalPages}
                  onClick={() => setPagination(prev => ({ ...prev, page: prev.page + 1 }))}
                >
                  下一页
                </button>
              </div>
            )}
          </>
        )}
      </div>
    </div>
  );
};

export default History;
